// FlowChart CRUD
export const GET_BOARD_FLOW_CHARTS = "FlowChart/GET_BOARD_FLOW_CHARTS";
export const GET_FLOW_CHART_BY_ID = "FlowChart/GET_FLOW_CHART_BY_ID";
export const CREATE_FLOW_CHART = "FlowChart/CREATE_FLOW_CHART";
export const UPDATE_FLOW_CHART = "FlowChart/UPDATE_FLOW_CHART";
export const SET_FLOW_CHART_ARCHIVE = "FlowChart/SET_FLOW_CHART_ARCHIVE";
export const DELETE_FLOW_CHART = "FlowChart/DELETE_FLOW_CHART";

// Task / TaskMap FlowChart CRUD
export const CREATE_TASK_FLOW_CHART = "FlowChart/CREATE_TASK_FLOW_CHART";
export const CREATE_TASK_MAP_FLOW_CHART =
  "FlowChart/CREATE_TASK_MAP_FLOW_CHART";
export const UPDATE_TASK_FLOW_CHART = "FlowChart/UPDATE_TASK_FLOW_CHART";
export const UPDATE_TASK_MAP_FLOW_CHART =
  "FlowChart/UPDATE_TASK_MAP_FLOW_CHART";
export const DELETE_TASK_FLOW_CHART = "FlowChart/DELETE_TASK_FLOW_CHART";
export const DELETE_TASK_MAP_FLOW_CHART =
  "FlowChart/DELETE_TASK_MAP_FLOW_CHART";

// FlowChart loading & error states
export const SET_FLOW_CHARTS_LOADING = "FlowChart/SET_FLOW_CHARTS_LOADING";
export const SET_FLOW_CHARTS_ERROR = "FlowChart/SET_FLOW_CHARTS_ERROR";
export const CLEAR_FLOW_CHART_STATE = "FlowChart/CLEAR_FLOW_CHART_STATE";
export const CLEAR_CURRENT_FLOW_CHART = "FlowChart/CLEAR_CURRENT_FLOW_CHART";

// Section categories (Board.SectionCategories.FlowCharts)
export const GET_FLOW_CHART_CATEGORIES = "FlowChart/GET_FLOW_CHART_CATEGORIES";
export const SET_FLOW_CHART_CATEGORIES_LOADING =
  "FlowChart/SET_FLOW_CHART_CATEGORIES_LOADING";
export const SET_FLOW_CHART_CATEGORIES_ERROR =
  "FlowChart/SET_FLOW_CHART_CATEGORIES_ERROR";
